import styles from './skeleton.module.scss';
import { IconWrapper } from '@flexo/general';
import { useTranslation } from 'react-i18next';

const ENV = (import.meta as any).env;

interface ChartSkeletonProps {
  title: string;
  height?: number;
}

export function ChartSkeleton({ title, height }: ChartSkeletonProps) {
  const { t } = useTranslation();
  return (
    <div
      className={`${styles.ChartSkeleton} ${
        ENV?.VITE_APP_IS_WEB !== 'true' && styles.ChartSkeleton__Mobile
      } 
      
     `}
      style={
        ENV?.VITE_APP_IS_WEB !== 'true'
          ? { width: '100%', height: height, minHeight: height }
          : { width: '100%', height: height, minHeight: height }
      }
    >
      <div className={styles.ChartSkeleton__Header}>
        <div className={styles.ChartSkeleton__Header__Title}>{t(title)}</div>
        <div className={styles.ChartSkeleton__Header__Labels}>
          <div className={styles.ChartSkeleton__Header__Labels__Label}></div>
          <div className={styles.ChartSkeleton__Header__Labels__Label}></div>
          <div className={styles.ChartSkeleton__Header__Labels__Label}></div>
        </div>
      </div>

      <div className={styles.ChartSkeleton__Content}>
        <div className={styles.ChartSkeleton__Content__Unit}></div>
        <div className={styles.ChartSkeleton__Content__Axes}>
          <IconWrapper iconName={'loading'} style={{ marginBottom: 8 }} />
          <div className={styles.Skeletons__Label}>{t('charts.loading')}</div>
        </div>
        <div className={styles.ChartSkeleton__Content__TimeSets}>
          <div
            className={styles.ChartSkeleton__Content__TimeSets__TimeSet}
          ></div>
          <div
            className={styles.ChartSkeleton__Content__TimeSets__TimeSet}
          ></div>
          <div
            className={styles.ChartSkeleton__Content__TimeSets__TimeSet}
          ></div>
          <div
            className={styles.ChartSkeleton__Content__TimeSets__TimeSet}
          ></div>
        </div>
      </div>
    </div>
  );
}
